// src/data/servicesData.js
import React from 'react';
// Import icons used for the services
import { BsBuildingCheck, BsClipboardCheck, BsHammer } from 'react-icons/bs';
import { FaHandshake } from 'react-icons/fa';

// --- Define the .lottie URLs as simple strings ---
// Replace placeholder URLs with your actual .lottie file URLs from LottieHost/LottieFiles
const developmentLottieUrl = "https://lottie.host/c6f4caff-d4c2-4728-a339-b4ea68768cad/n765mYUd5O.lottie"; // Example URL
const constructionLottieUrl = "https://lottie.host/dc177837-fb5f-4fb1-ab87-096f083d2fc0/9JY2cYdH73.lottie"; // Replace with actual URL
const managementLottieUrl = "https://lottie.host/51fc8705-4533-4fb9-9f7d-ee7890080fb0/gbef4G8JGh.lottie"; // Replace with actual URL
const relationsLottieUrl = "https://lottie.host/761782e0-217d-48cb-a39c-6fb9e1e94334/GtY3Gbtftf.lottie"; // Replace with actual URL

// Array holding the data for each service
const servicesData = [
    {
        // Icon component for the service
        icon: <BsBuildingCheck />,
        // Title of the service
        title: 'Property Development',
        // Short description (used on landing page cards)
        description: 'From initial concept to delivering finished residential projects.',
        // More detailed points (used on the dedicated services page)
        details: [
            "Full lifecycle management: land acquisition, planning, design, execution.",
            "Experience developing diverse projects: duplexes, apartment complexes.",
            "Focus on creating value and desirable living spaces.",
            "Strategic site selection in prime locations like Florești and Cluj-Napoca."
        ],
        // The direct URL to the .lottie animation file for this service
        lottieSrcUrl: developmentLottieUrl,
    },
    {
        icon: <BsHammer />,
        title: 'Construction & Execution',
        description: 'High-quality construction including structure, finishing, and insulation.',
        details: [
            "Dedicated in-house team ensuring quality control.",
            "Expertise in structural work, gained through years of experience.",
            "High standards for finishing touches and thermal insulation.",
            "Strong relationships with reliable subcontractors.",
            "Commitment to using quality materials and building practices."
        ],
        lottieSrcUrl: constructionLottieUrl, // Replace placeholder
    },
    {
        icon: <BsClipboardCheck />,
        title: 'Project Management & Quality Assurance',
        description: 'Ensuring quality, promptness, and adherence to deadlines.',
        details: [
            "Proven track record with over 100 projects implemented.",
            "Meticulous planning and execution monitoring.",
            "Strict adherence to agreed timelines and budgets.",
            "Rigorous quality control checks at every stage.",
            "Transparent communication throughout the project."
        ],
        lottieSrcUrl: managementLottieUrl, // Replace placeholder
    },
    {
        icon: <FaHandshake />,
        title: 'Client Relations & After-Sales Care',
        description: 'Prioritizing client satisfaction before, during, and after the sale.',
        details: [
            "Building trust through open communication and reliability.",
            "Dedicated support throughout the purchasing process.",
            "Emphasis on post-purchase care and addressing client needs.",
            "Driven by achieving client satisfaction and earning recommendations.",
            "Passionate about helping clients make the right choice."
        ],
        lottieSrcUrl: relationsLottieUrl, // Replace placeholder
    },
];

// Export the array to be used in other components
export default servicesData;
